/**
 * Why Us: trust-focused section. Complements How It Works (no duplicate three pillars).
 */
export default function WhyUsIndex() {
  return (
    <section id="why-us" className="py-8 sm:py-12 bg-blue-100/30">
      <div className="container px-4 sm:px-6">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 lg:p-16 shadow-xl border border-gray-100/50">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-semibold text-dark mb-4 sm:mb-6 tracking-tight px-2">
              Why brands trust it
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto font-dm-sans leading-relaxed px-4">
              A format that fits how brand and agency teams evaluate creators.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-12 mb-12 sm:mb-16">
            <div className="text-center p-6 sm:p-8">
              <div className="text-2xl sm:text-3xl mb-3" aria-hidden>📋</div>
              <h3 className="text-lg sm:text-xl font-display font-semibold text-dark mb-2 sm:mb-3 tracking-tight">Structured format</h3>
              <p className="text-sm sm:text-base text-gray-600 font-dm-sans leading-relaxed">Platforms, stats, and collab history in one consistent layout so brands can compare creators quickly.</p>
            </div>
            <div className="text-center p-6 sm:p-8">
              <div className="text-2xl sm:text-3xl mb-3" aria-hidden>📈</div>
              <h3 className="text-lg sm:text-xl font-display font-semibold text-dark mb-2 sm:mb-3 tracking-tight">Live performance data</h3>
              <p className="text-sm sm:text-base text-gray-600 font-dm-sans leading-relaxed">Your engagement rate and average views update automatically, so brands always see current performance.</p>
            </div>
            <div className="text-center p-6 sm:p-8">
              <div className="text-2xl sm:text-3xl mb-3" aria-hidden>🤝</div>
              <h3 className="text-lg sm:text-xl font-display font-semibold text-dark mb-2 sm:mb-3 tracking-tight">Clear collab history</h3>
              <p className="text-sm sm:text-base text-gray-600 font-dm-sans leading-relaxed">Past brand partnerships in one place so you can show proof without digging through DMs.</p>
            </div>
          </div>
          <div className="rounded-xl sm:rounded-2xl bg-gradient-to-br from-primary/10 to-accent/10 border border-primary/20 p-6 sm:p-8 text-center">
            <h3 className="text-lg sm:text-xl font-display font-semibold text-dark mb-2 sm:mb-3 tracking-tight">Designed with brands</h3>
            <p className="text-sm sm:text-base text-gray-700 font-dm-sans leading-relaxed max-w-2xl mx-auto">
              Profile structure informed by feedback from 15+ brands and agencies in influencer marketing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
